"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M23.48 11.48A.52.52 0 0 1 24 12c0 6.616-5.384 12-12 12-4.417 0-8.126-2.433-10.769-7.05l-.192-.342v2.913a.52.52 0 0 1-1.03.094L0 19.522v-3.96a.52.52 0 0 1 .426-.51l.093-.008h3.96a.52.52 0 0 1 .093 1.03l-.094.008H1.932c1.741 3.183 4.882 6.878 10.069 6.878 6.043 0 10.96-4.916 10.96-10.96a.52.52 0 0 1 .52-.52ZM12 0c4.419 0 8.126 2.434 10.769 7.05l.192.342V4.478a.52.52 0 0 1 1.031-.093l.008.093v3.959a.521.521 0 0 1-.426.512l-.094.008h-3.959a.52.52 0 0 1-.093-1.032l.093-.008h2.547C20.326 4.736 17.186 1.039 12 1.039 5.957 1.039 1.04 5.956 1.04 12A.52.52 0 0 1 0 12C0 5.383 5.383 0 12 0Z",
    clipRule: "evenodd"
  })]
});